import React, { useEffect, useRef } from 'react';
import H from '@here/maps-api-for-javascript';
import { useDispatch } from 'react-redux';
import withTranslation from '../../../hoc/withTranslation';
import { enhanceUnselectedStopGeoJSONFeatures } from './utils/unselectedStopMarkerHelpers';
import { updateUnselectedStopGroupMarkers } from './utils/unselectedStopMarkerFactory';
import { attachUnselectedStopHoverEvents } from './utils/unselectedStopMarkerEvents';
import { areMarkerPropsEqual } from '../utils/markerPropsUtils';

const NewUnselectedStopMarkers = ({ translations, map, geoJSON, ui, user, display }) => {
  const dispatch = useDispatch();
  const groupRef = useRef(null);
  const translationsRef = useRef(translations);

  useEffect(() => {
    translationsRef.current = translations;
  });

  useEffect(() => {
    if (map) {
      groupRef.current = new H.map.Group();
      map.addObject(groupRef.current);
    }
    return () => {
      if (groupRef.current) {
        groupRef.current.removeAll();
        map.removeObject(groupRef.current);
        groupRef.current = null;
      }
    };
  }, [map]);

  useEffect(() => {
    if (!groupRef.current || !ui.current) return;

    if (!geoJSON?.geo?.features || geoJSON.geo.features.length === 0) {
      groupRef.current.removeAll();
      return;
    }

    if (!user?.mapSettings?.showStops) {
      groupRef.current.removeAll();
      return;
    }

    const hideVisited = user?.mapSettings?.hideVisited || false;
    const enhancedGeoJSON = enhanceUnselectedStopGeoJSONFeatures(geoJSON, display, hideVisited);

    if (!enhancedGeoJSON?.geo?.features || enhancedGeoJSON.geo.features.length === 0) {
      groupRef.current.removeAll();
      return;
    }

    updateUnselectedStopGroupMarkers(
      enhancedGeoJSON,
      groupRef.current,
      translationsRef,
      map,
      attachUnselectedStopHoverEvents,
      dispatch,
    );
  }, [geoJSON, map, translations, ui, display, user, dispatch]);

  return null;
};

const MemoizedNewUnselectedStopMarkers = React.memo(NewUnselectedStopMarkers, areMarkerPropsEqual);

export default withTranslation(MemoizedNewUnselectedStopMarkers);
